import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function CustomDrawerComponent() {
  const navigate = useNavigate();

  return (
    <Box sx={{ padding: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/some-screen')} // Navigate to a route
      >
        Go somewhere
      </Button>
    </Box>
  );
}
